export default __webpack_public_path__ + "static/split-logo-dark-29681af9d804a8afd1e2256895be2b19.png";